import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { Buyer, BuyersService, ListBuyersParams } from 'src/app/core/buyers.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { ERROR_BUYER_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-buyers-data',
  templateUrl: './buyers-data.component.html',
  styleUrls: ['./buyers-data.component.scss'],
})
export class BuyersDataComponent {
  @ViewChild('buyers_load_more') load_more_layout?: ElementRef;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = true;
  is_load_more_running: boolean = true;
  buyers?: Buyer[];
  cursor: string | null = null;
  total?: number;
  filters?: ListBuyersParams;

  constructor(private buyers_service: BuyersService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.buyers = [];
    this.cursor = null;
    this.filters = undefined;
    this.total = undefined;
    this.listBuyers();
  }

  onRefresh(): void {
    this.buyers = [];
    this.cursor = null;
    this.filters = undefined;
    this.total = undefined;
    this.listBuyers();
  }

  onFilter(filters?: ListBuyersParams): void {
    this.buyers = [];
    this.cursor = null;
    this.total = undefined;
    this.filters = filters;
    this.listBuyers(filters);
  }

  onScrollEnd(): void {
    if (this.cursor && !this.is_load_more_running) this.onLoadMoreClick();
  }

  onLoadMoreClick(): void {
    this.listBuyers(this.filters, true);
  }

  listBuyers(filters?: ListBuyersParams, is_load_more_running?: boolean): void {
    this.is_list_running = !is_load_more_running;
    this.is_load_more_running = is_load_more_running || false;

    const list_buyers_params = {
      ...filters,
      cursor: this.cursor,
    };

    this.buyers_service.listBuyers(list_buyers_params).subscribe({
      next: response => {
        const buyers = response.data.data;
        this.buyers = (this.buyers ? this.buyers : []).concat(buyers);
        this.cursor = response.data.cursor;
        if (list_buyers_params.cursor == undefined) {
          this.total = response.data.total.value;
        }

        this.is_list_running = false;
        this.is_load_more_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_BUYER_NOT_FOUND) {
          this.buyers = [];
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_list_running = false;
        this.is_load_more_running = false;
      },
    });
  }
}
